import { useContext, useEffect } from "react";
import { TabelaStyled } from "../../Styles/admin";
import { Footer } from "../../components/Footer";
import { Header, HeaderMobil } from "../../components/Header";
import { LogoBG } from "../../components/logoBG";
import { AdminContext } from "../../Context/ContextAdmin";
import { apiSae } from "../../services/api";
import {
  ModalsCreateBomba,
  ModalsCreateBombaPoco2,
  ModalsCreatePoco,
  ModalsCreateEstacao,
  ModalsUpdateEstacao,
  ModalsDesableEstacao,
} from "./modals";
import { toast } from "react-toastify";

export const AdminElevatorias = () => {
  const {
    estacoes,
    setEstacoes,
    setPocos,
    setBombas,
    headerApi,
    modalCreateEstacao,
    modalUpdateEstacao,
    setModalCreateEstacao,
    modalCreatePoco,
    modalCreateBomba,
    modalCreateBombaPoco2,
    selecionaEstacoes,
    setSelecionaEstacoes,
    aoListarGeral,
    modalsDesableEstacao,
    setDesableEstacao,
  } = useContext(AdminContext);

  const renderEstacoes = async () => {
    try {
      const Response = await apiSae.get("/estacao/leituratodos", headerApi);
      const ResponsePoco = await apiSae.get("poco/leituratodos", headerApi);
      const ResponseBombas = await apiSae.get("bomba/LeituraTodos", headerApi);

      setEstacoes(Response.data);
      setPocos(ResponsePoco.data);
      setBombas(ResponseBombas.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    renderEstacoes();
  }, []);

  if (!estacoes) {
    return <div>Loading..</div>;
  }

  return (
    <TabelaStyled>
      {modalCreateEstacao && <ModalsCreateEstacao />}
      {modalUpdateEstacao && <ModalsUpdateEstacao />}
      {modalCreatePoco && <ModalsCreatePoco />}
      {modalCreateBomba && <ModalsCreateBomba />}
      {modalCreateBombaPoco2 && <ModalsCreateBombaPoco2 />}
      {modalsDesableEstacao && <ModalsDesableEstacao />}

      <Header pgRedireciona="/admin" />
      <HeaderMobil pgRedireciona="/admin" />
      <div className="bloco">
        <h3>Lista de Estações</h3>
        <div className="blocoTabela">
          <table className="blueTable">
            <thead>
              <tr>
                <th>Id</th>
                <th>Estação</th>
                <th>Tipo de Estação</th>
                <th>Qtd. Poços</th>
                <th>Qtd. Bombas</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {estacoes.map((estacao) => {
                return (
                  <tr
                    key={estacao.id}
                    onClick={() =>
                      setSelecionaEstacoes([estacao.id, estacao.ativo])
                    }
                    className={selecionaEstacoes[0] === estacao.id && "select"}
                  >
                    <td>{estacao.id}</td>
                    <td>{estacao.nome_estacao}</td>
                    <td>{estacao.tipo}</td>
                    <td>{estacao.pocos?.length ?? 0}</td>

                    <td>
                      {estacao.pocos && estacao.pocos[0]
                        ? estacao.pocos[0].bombas.length +
                          (estacao.pocos[1]?.bombas.length ?? 0)
                        : "--"}
                    </td>

                    <td>{estacao.ativo ? "Ativa" : "Inativa"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="Botao">
          <button onClick={() => setModalCreateEstacao(true)}>Adicionar</button>
          <button
            onClick={() => {
              aoListarGeral();
            }}
          >
            Editar
          </button>
          <button
            onClick={() => {
              if (selecionaEstacoes.length === 2) {
                setDesableEstacao(true);
              } else {
                toast.warn("Selecione uma estação primeiro!");
              }
            }}
          >
            {selecionaEstacoes[1] ? "Desativar" : "Ativar"}
          </button>
        </div>
      </div>

      <LogoBG />
      <Footer relative={true} background={true} />
    </TabelaStyled>
  );
};
